<template>
  <el-card>
    <template #header>
      <h4>{{ $t('菜谱管理中心') }}</h4>
    </template>

    <el-row v-for="(l1, index) in rowData" :key="index">
      <el-col v-for="(item, lIndex) in l1" :key="lIndex" :span="5">
        <div class="item">
          <span>{{ $t(item.name) }}</span>
          <span class="count">{{ data[item.key] || 0 }}</span>
        </div>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
export default {
  name: "RecipeStat",
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      rowData: [
        [
          { name: '上架中的菜谱总量', count: 0, key: "upCbCount" },
          { name: '审核未通过总量', count: 0, key: "totalNoPassCbCount" },
          { name: '今日上传菜谱数量', count: 0, key: "todayCbCount" },
          { name: '上传菜谱总量', count: 0, key: "totalCbCount" },
        ],
        [
          { name: '今日审核通过数量', count: 0, key: "todayPassCbCount" },
          { name: '今日审核未通过菜谱', count: 0 , key: "todayNoPassCbCount"},
          { name: '待审核数量', count: 0, key: "toAuditCbCount" },
        ],
        [
          { name: '今日下架的菜谱数量', count: 0, key: "todayDownCbCount" },
          { name: '下架的菜谱总量', count: 0, key: "totalDownCbCount" },
          { name: '今日删除菜谱数量', count: 0, key: "todayDeleteCbCount" },
          { name: '删除菜谱总量', count: 0, key: "totalDeleteCbCount" },
        ],
      ]
    }
  }
}
</script>

<style scoped>

.el-row {
  margin-bottom: 50px;
}

.el-row:last-child {
  margin-bottom: 0;
}

.item {
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 10px;
}

.count {
  font-weight: 600;
  font-size: 20px;
}

</style>
